import { LayoutWorkstationSidebar } from "@/components/_layouts/LayoutWorkstationSidebar/LayoutWorkstationSidebar";
import { getDefaultDealDirectoryEntity } from "@/models/dealDirectory";
import { Loader } from "@mantine/core";
import { useDocumentTitle } from "@mantine/hooks";
import { useAtomValue } from "jotai";
import { Main } from "./Main/Main";
import { Sidebar } from "./Sidebar/Sidebar";

export const DealTrackerPage = () => {
  useDocumentTitle("ETA IQ - Deal Tracker");
  const ar = getDefaultDealDirectoryEntity();
  const { data: dealDirectiory, error } = useAtomValue(
    ar.getObserveEntityRecordAtom(),
  );

  if (error) {
    console.error("Error loading", error);
    return (
      <div>
        <h1>Error</h1>
        <p>
          {error.message}. If your are receiving this message please contact
          help@etaiq.com. SUPPORT CODE: KHDJ-23
        </p>
      </div>
    );
  }

  if (!dealDirectiory)
    return (
      <Loader
        size={50}
        pos={"absolute"}
        left={"50%"}
        top={"40%"}
        opacity={0.1}
      />
    );

  return (
    <LayoutWorkstationSidebar sidebar={<Sidebar />} size={"sm"}>
      <Main />
    </LayoutWorkstationSidebar>
  );
};
